import Vue from "@/main";
import { Message } from "element-ui";

import czmlUrl from "./car.json";
import lujing_01 from "./lujing_01.json";
import lujing_02 from "./lujing_02.json";

export let graphicLayer; // 矢量图层对象
export let graphicLayer2; // 矢量图层对象
let positions = []; //
let savePaths = []; // 路径
let indexs = 1;
let basePathUrl = window.basePathUrl || "";
let pathData = [];
let vehicleSum = 10;
let carVelocity = 4;
let intervalDate = 1.5;

//车牌号所在地区
let citys = [
  "京",
  "津",
  "晋",
  "湘",
  "赣",
  "沪",
  "渝",
  "冀",
  "台",
  "辽",
  "吉",
  "黑",
  "苏",
  "浙",
  "皖",
  "闽",
  "鲁",
  "豫",
  "鄂",
  "青",
  "粤",
  "琼",
  "川",
  "贵",
  "云",
  "陕",
  "甘",
  "藏",
  "桂",
  "蒙",
  "宁",
  "新",
  "港",
  "澳",
];
//车牌号所在地区
let area = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "J",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
];
//车牌号后5位
let nums = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "J",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
];
export function pathDataFun() {
  var pathData = [];
  let arr = JSON.parse(
    JSON.stringify(lujing_01.features[0].geometry.coordinates)
  );

  console.log(pathData, "pathData");

  for (let i = 0; i < arr.length; i++) {
    arr[i].unshift(999999);
    for (let v = 0; v < arr[i].length; v++) {
      pathData.push(arr[i][v]);
    }
  }
  savePaths.push(pathData);
  console.log(savePaths, "第一条第一条第一条第一条");
}

export function pathDataFun2() {
  var pathData = [];
  let arr = JSON.parse(
    JSON.stringify(lujing_02.features[0].geometry.coordinates)
  );

  for (let i = 0; i < arr.length; i++) {
    arr[i].unshift(999999);
    for (let v = 0; v < arr[i].length; v++) {
      pathData.push(arr[i][v]);
    }
  }
  savePaths.push(pathData);
  console.log(savePaths, "第二条第二条第二条第二条");
}
// 113.93543348699828, 22.524515811414847;

graphicLayer = new mars3d.layer.GraphicLayer();
Vue.$GLOBAL.map.addLayer(graphicLayer);
graphicLayer2 = new mars3d.layer.GraphicLayer();
Vue.$GLOBAL.map.addLayer(graphicLayer2);

// 地图选点
export function setPoint() {
  graphicLayer.startDraw({
    type: "point",
    style: {
      color: "#00ffff",
      width: 3,
      visibleDepth: false, //是否被遮挡
      clampToGround: false,
      label: {
        // 不需要文字时，去掉label配置即可
        text: indexs.toString(),
        font_size: 20,
        color: "#ffffff",
        outline: true,
        outlineColor: "#000000",
        pixelOffsetY: -20,
      },
    },
    // addHeight: 100,
    //点
    success: (graphic) => {
      console.log(graphic, "graphic");
      let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
        graphic._position_draw
      );
      // alt 高度（单位：米） lat 纬度  lng 经度
      positions.push(999999);
      positions.push(_lng);
      positions.push(_lat);
      positions.push(_alt);
      // positions.push([time, _lng, _lat, _alt]);
      console.log(positions, "positions");
      indexs += 1;
    },
    //线
    // success: (graphic) => {
    //   console.log(graphic);
    //   for (let i = 0; i < graphic._positions_draw.length; i++) {
    //     let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
    //       graphic._positions_draw[i]
    //     );
    //     // alt 高度（单位：米） lat 纬度  lng 经度
    //     positions.push(999999);
    //     positions.push(_lng);
    //     positions.push(_lat);
    //     positions.push(_alt);
    //     // positions.push([time, _lng, _lat, _alt]);
    //     console.log(positions, "positions");
    //     // indexs += 1;
    //   }
    // },
  });

  // graphicLayer.on(mars3d.EventType.click, function (event) {
  //   console.log("监听layer，单击了矢量对象", event);
  //   for (let i = 0; i < event.graphic._positions_draw.length; i++) {
  //     addDot(event.graphic._positions_draw[i], i);
  //   }
  // });

  graphicLayer.on(mars3d.EventType.drawAddPoint, function(event) {
    console.log("矢量数据对象加载完成", event);
    addDot(event.cartesian);
    indexs += 1;
  });
}
function addDot(item) {
  // :113.93096937, 纬度:22.55751304,
  let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(item);
  // console.log(_lng);
  // console.log(_lat);
  // let arr = [113.93096937, 22.55751304, 0];
  let arr = [_lng, _lat, _alt];
  let graphic = new mars3d.graphic.PointEntity({
    position: arr,
    style: {
      color: "#ff0000",
      pixelSize: 10,
      outlineColor: "#ffffff",
      outlineWidth: 2,
      visibleDepth: false, //是否被遮挡
      label: {
        text: indexs.toString(),
        font_size: 18,
        color: "#ffffff",
        pixelOffsetY: -10,
        distanceDisplayCondition: true,
        distanceDisplayCondition_far: 500000,
        distanceDisplayCondition_near: 0,
      },
    },
    attr: { remark: "示例1" },
  });

  graphicLayer.addGraphic(graphic);
}
//保存路线
export function savePath() {
  // addDot();
  if (positions.length) {
    savePaths.push(positions);
    Message({
      message: "恭喜你，这是一条成功消息",
      type: "success",
    });
    positions = [];
    indexs = 1;
    graphicLayer.clear();
    console.log(savePaths, "savePaths");
    // this.$GLOBAL.map.removeLayer(this.graphicLayer)
    // this.graphicLayer.endDraw()
  } else {
    Message({
      message: "请先在地图选点",
      type: "warning",
    });
  }
}

export function showAircraft() {
  removeLayer();

  let czmlObj = [
    {
      version: "1.0",
      id: "document",
      clock: {
        interval: "2018-09-15T04:00:00Z/2018-09-16T12:01:22.4928217109991Z",
        currentTime: "2018-09-15T04:00:00Z",
        multiplier: 1,
      },
      style: {
        distanceDisplayCondition: true,
        distanceDisplayCondition_far: 1000,
        distanceDisplayCondition_near: 0,
      },
    },
  ];

  let index0 = 0;

  savePaths.forEach((item, elindex) => {
    index0 = 0;
    console.log(elindex, vehicleSum);
    for (let i = 0; i < vehicleSum; i++) {
      if (i > 0) {
        index0 += intervalDate;
      }
      czmlObj.push(JSON.parse(JSON.stringify(addData(0, index0, elindex, i))));
    }
  });

  console.log(czmlObj, "czmlObj");
  // console.log(JSON.stringify(czmlObj));

  if (czmlObj.length > 50) {
    variant(czmlObj, 50);
    return;
  }
  console.log("小于50");
  // return;
  graphicLayer = new mars3d.layer.CzmlLayer({
    name: "汽车",
    data: czmlObj,
    // flyTo: true,
  });
  Vue.$GLOBAL.map.addLayer(graphicLayer);

  // 绑定事件
  // graphicLayer.on(mars3d.EventType.load, function (data) {
  //   console.log("数据加载完成", data);
  //   eventTarget.fire("loadGraphicLayer", { data });
  // });
  // graphicLayer.on(mars3d.EventType.click, function (event) {
  //   console.log("单击了图层", event);
  // });
}
function variant(czmlObj, i) {
  let arr = [];
  let index = i;
  arr = czmlObj.slice(1, index + 1);
  arr.unshift(czmlObj[0]);

  console.log(11111);
  console.log(arr, "arrarrarr");
  console.log(czmlObj);

  if (czmlObj[i + 51]) {
    variant(czmlObj, (i += 50));
  } else {
    let arr2 = [];
    arr2 = czmlObj.slice(index + 1, czmlObj.length);
    arr2.unshift(czmlObj[0]);
    console.log(222222);
    console.log(arr2, "arr2arr2");

    if (arr2.length > 1) {
      // let layer2 = new mars3d.layer.CzmlLayer({
      //   name: "汽车",
      //   data: arr2,
      //   // flyTo: true,
      // });
      // Vue.$GLOBAL.map.addLayer(layer2);
    }
  }
}
function removeLayer() {
  // Vue.$GLOBAL.map.removeLayer(graphicLayer, true);
  // graphicLayer = null;
}

function addData(time, index0, elindex, i) {
  // console.log(savePaths[elindex]);
  let obj = {
    id: i + 1,
    name: i,
    availability: "2018-09-15T04:00:00Z/2018-09-16T10:37:06.58425997800077Z",
    orientation: { velocityReference: "#position" },
    position: {
      epoch: "2018-09-15T04:00:00Z",

      cartographicDegrees: savePaths[elindex],
    },
    model: {
      show: true,
      gltf: "/gltf/cart/benchi1.gltf",
      scale: 1,
      minimumPixelSize: 50,
    },
    label: {
      fillColor: {
        rgba: [0, 255, 255, 255],
      },
      font: "21pt Lucida Console",
      horizontalOrigin: "LEFT",
      outlineColor: {
        rgba: [0, 0, 0, 255],
      },
      outlineWidth: 2,
      pixelOffset: {
        cartesian2: [0, -30],
      },
      scale: 0.5,
      show: true,
      style: "FILL_AND_OUTLINE",
      text: "AA" + ++i,
      verticalOrigin: "CENTER",
    },
  };
  // 变速
  // variableSpeed(0);
  // 匀速
  constantSpeed(0, time, index0, elindex);
  return obj;
}

function constantSpeed(i, time, index0, elindex) {
  let index = i;
  if (i == 0) {
    savePaths[elindex][0] = index0;
    if (savePaths[elindex][index + 4]) {
      index += 4;
      constantSpeed(index, time, index0, elindex);
    }
  } else {
    if (savePaths[elindex][index]) {
      savePaths[elindex][index] = time + carVelocity + index0;
      index += 4;
      let a = time + carVelocity;
      constantSpeed(index, 0, index0, elindex);
    }
  }
}
function variableSpeed(i) {
  let index = i;
  if (i == 0) {
    savePaths[0][0] = 0;
    if (savePaths[0][index + 4]) {
      index += 4;
      variableSpeed(index);
    }
  } else {
    if (savePaths[0][index]) {
      savePaths[0][index] = generateRandomInteger(index, index + 4);
      index += 4;
      variableSpeed(index);
    }
  }
}

export function suspend() {
  Vue.$GLOBAL.map.clock.shouldAnimate = !Vue.$GLOBAL.map.clock.shouldAnimate;
}
export function setVehicleSum(num) {
  vehicleSum = num;
}
export function setCarVelocity(num) {
  carVelocity = num;
}
export function setIntervalDate(num) {
  intervalDate = num;
}
export async function reset() {
  positions = [];
  savePaths = JSON.stringify(savePaths);
  savePaths = "null";
  savePaths = JSON.parse(JSON.stringify([]));
  indexs = 1;
  vehicleSum = 10;
  carVelocity = 4;
  intervalDate = 1.5;
  pathData = JSON.stringify(pathData);
  pathData = null;
  pathData = JSON.parse(JSON.stringify([]));
  graphicLayer.clear();
  graphicLayer2.clear();
  graphicLayer = null;
  graphicLayer = new mars3d.layer.GraphicLayer();
  Vue.$GLOBAL.map.addLayer(graphicLayer);
  console.log(savePaths);
  console.log("重置成功!");
  Message({
    message: "重置成功",
    type: "success",
  });
}
function generateRandomInteger(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
function createLicencePlate() {
  return getcity() + getarea() + getend5(5);
}

//省份生成
function getcity() {
  var id = Math.floor(Math.random() * 34);
  return citys[id];
}
//地区生成
function getarea() {
  var id = Math.floor(Math.random() * 17);
  return area[id];
}
//车牌后五位
function getend5(n) {
  var res = "";
  for (var i = 0; i < n; i++) {
    var id = Math.floor(Math.random() * 36);
    res += nums[id];
  }
  return res;
}
//日期转国际化
export function internationalizationDate(date) {
  let dateStart = "2019-03-27 12:40:00";
  let dateEnd = "2019-03-27 12:50:15";

  console.log(
    new Date(dateStart).toISOString() + "/" + new Date(dateEnd).toISOString()
  );

  console.log(new Date("2022-01-01 12:40:00").toUTCString());
  console.log(new Date("2022-01-01 12:50:15").toUTCString());
}
